export const CRM_URL = {
  ROLE: '/v1/roles',
  PERMISSIONS: '/v1/user-permissions',
}
